export function kebabCaseToCamelCase(str) {
    return str
        .split('-')
        .map((word, index) => (index ? capitalizeFirstChar(word) : word))
        .join('');
}
export function camelCaseToKebabCase(str) {
    return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}
export function isLowerCase(str) {
    return /^[a-z]*$/.test(str);
}
function capitalizeFirstChar(str) {
    if (!str) {
        return str;
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const firstChar = str[0].toUpperCase();
    return `${firstChar}${str.slice(1)}`;
}
//# sourceMappingURL=wordsCase.js.map